export enum manualTransferFormFields {
  transferTo = 'transferTo',
  amount = 'amount',
}
